import { ServiceType } from '../../../../entities';

import defaultSvg from '../../../../assets/services/Default.svg';
import bikeSvg from '../../../../assets/services/Bike.svg';
import chefSvg from '../../../../assets/services/ChefStudio.svg';
import coworkingSvg from '../../../../assets/services/Coworking.svg';
import gameRoomSvg from '../../../../assets/services/GameRoom.svg';
import grillSvg from '../../../../assets/services/Grill.svg';
import gymSvg from '../../../../assets/services/Gym.svg';
import hairStylistSvg from '../../../../assets/services/HairStylist.svg';
import massageSvg from '../../../../assets/services/Massage.svg';
import meetingRoomSvg from '../../../../assets/services/MeetingRoom.svg';
import partyRoomSvg from '../../../../assets/services/PartyRoom.svg';
import steamRoomSvg from '../../../../assets/services/SteamRoom.svg';
import washerSvg from '../../../../assets/services/Washer.svg';
import squashSvg from '../../../../assets/services/SquashCourt.svg';
import tenisCourtSvg from '../../../../assets/services/TenisCourt.svg';
import multiSportCourtSvg from '../../../../assets/services/MultiSportCourt.svg';
import fightRoomSvg from '../../../../assets/services/FightRoom.svg';
import poolSvg from '../../../../assets/services/Pool.svg';

const Mapper: Record<ServiceType, string> = {
  [ServiceType.Default]: defaultSvg,
  [ServiceType.Bike]: bikeSvg,
  [ServiceType.ChefStudio]: chefSvg,
  [ServiceType.Coworking]: coworkingSvg,
  [ServiceType.GameRoom]: gameRoomSvg,
  [ServiceType.Grill]: grillSvg,
  [ServiceType.Gym]: gymSvg,
  [ServiceType.HairStylist]: hairStylistSvg,
  [ServiceType.Massage]: massageSvg,
  [ServiceType.MeetingRoom]: meetingRoomSvg,
  [ServiceType.PartyRoom]: partyRoomSvg,
  [ServiceType.SteamRoom]: steamRoomSvg,
  [ServiceType.Washer]: washerSvg,
  [ServiceType.SquashCourt]: squashSvg,
  [ServiceType.TenisCourt]: tenisCourtSvg,
  [ServiceType.MultiSportCourt]: multiSportCourtSvg,
  [ServiceType.FightRoom]: fightRoomSvg,
  [ServiceType.Pool]: poolSvg,
};

export const getDefaultImage = (type: ServiceType): string => Mapper[type];

export default getDefaultImage;
